import React, { FC } from 'react';
import { ReactComponent as SectionImage1 } from 'assets/svgs/resource-management/template_section_1.svg';
import { ReactComponent as SectionImage2 } from 'assets/svgs/resource-management/template_section_2.svg';
import { Button } from 'components/atoms/button';
import { FeatureDiscovery } from 'components/molecules/feature-discovery';
import { useTranslation } from 'hooks/use-translation';

const {
  Section: { Content, Media },
  BannerSection: { Content: BannerContent, Media: BannerMedia },
} = FeatureDiscovery;

export const ResourceManagementFeatureDiscovery: FC<{
  onGetStarted: () => void;
}> = ({ onGetStarted }) => {
  return (
    <FeatureDiscovery>
      <FeatureDiscovery.BannerSection>
        <BannerMedia>
          <SectionImage1 />
        </BannerMedia>
        <BannerContent>
          <BannerContent.Title>
            {useTranslation(
              'templates.resource_management.feature_discovery.section_1.title',
            )}
          </BannerContent.Title>
          <BannerContent.Description>
            {useTranslation(
              'templates.resource_management.feature_discovery.section_1.description',
            )}
          </BannerContent.Description>
          <BannerContent.Actions>
            <Button onClick={onGetStarted} type="primary">
              {useTranslation('get_started')}
            </Button>
          </BannerContent.Actions>
        </BannerContent>
      </FeatureDiscovery.BannerSection>
      <FeatureDiscovery.Section>
        <Media>
          <SectionImage2 />
        </Media>
        <Content>
          <Content.Title>
            {useTranslation(
              'templates.resource_management.feature_discovery.section_2.title',
            )}
          </Content.Title>
          <Content.Description>
            {useTranslation(
              'templates.resource_management.feature_discovery.section_2.description',
            )}
          </Content.Description>
          <Content.Actions>
            <Button onClick={onGetStarted} type="primary">
              {useTranslation('get_started')}
            </Button>
          </Content.Actions>
        </Content>
      </FeatureDiscovery.Section>
    </FeatureDiscovery>
  );
};
